
// T161 — shared by AvailableCard, AvailableRow and RecActions.

export default function ActionButton({ children, active, disabled, onClick, title }) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      title={title}
      className={
        'rounded px-2.5 py-1 text-xs transition disabled:opacity-50 ' +
        (active
          ? 'bg-brand-600 text-white hover:bg-brand-500'
          : 'border border-slate-700 text-slate-300 hover:border-brand-600 hover:text-brand-400')
      }
    >
      {children}
    </button>
  );
}
